import BaseCard from 'components/Cards/BaseCard';
import ConfirmationModal from 'components/Modals/ConfirmationModal';
import WidgetLoadingAnimation from 'components/Widgets/WidgetLoadingAnimation';
import { useState } from 'react';
import { Button } from 'react-bootstrap';
import { BsTrash } from 'react-icons/bs';
import { FaPencilAlt } from 'react-icons/fa';
import {
  useDeleteDutyMutation,
  useGetDutiesQuery,
} from 'services/duties/duties.api';
import Modal from '../components/Modal';
import { toast } from 'react-toastify';

const List = () => {
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedDuty, setSelectedDuty] = useState(null);
  const { data: duties, isFetching: dutiesFetching } = useGetDutiesQuery();
  const [deleteDuty] = useDeleteDutyMutation();

  const handleDelete = async () => {
    try {
      await deleteDuty(selectedDuty.id).unwrap();
      toast.success('Duty deleted successfully');
    } catch (error) {
      toast.error('Failed to delete duty. Please try again later.');
      console.error('Failed to delete duty', error);
    } finally {
      setShowDeleteModal(false);
    }
  };

  return (
    <>
      {!dutiesFetching ? (
        duties && (
          <div className="d-flex flex-column gap-3">
            {duties.map((duty) => (
              <BaseCard
                key={duty.id}
                title={
                  <div className="d-flex">
                    {duty.name}{' '}
                    <div className="ms-auto d-flex gap-3">
                      <Button
                        variant="primary"
                        className="btn-transparent p-0"
                        onClick={() => {
                          setSelectedDuty(duty);
                          setShowEditModal(true);
                        }}
                      >
                        <FaPencilAlt title="Edit" size={20} />
                      </Button>
                      <Button
                        variant="danger"
                        className="btn-transparent p-0"
                        onClick={() => {
                          setSelectedDuty(duty);
                          setShowDeleteModal(true);
                        }}
                      >
                        <BsTrash color="red" title="Delete" size={20} />
                      </Button>
                    </div>
                  </div>
                }
                className="rounded-3 border-1 border-white"
              >
                {duty.description}
              </BaseCard>
            ))}
            <Modal show={showEditModal} handleShow={() => setShowEditModal(false)} duty={selectedDuty} />
            <ConfirmationModal
              show={showDeleteModal}
              handleShow={() => setShowDeleteModal(false)}
              bodyTxt={`Are you sure you want to delete ${selectedDuty?.name}? This action cannot be undone.`}
              cancelBtnTxt="Cancel"
              confirmBtnTxt="Delete"
              confirmHandler={handleDelete}
            />
          </div>
        )
      ) : (
        <WidgetLoadingAnimation />
      )}
    </>
  );
};

export default List;
